import React from 'react';
import {
  CheckCircleIcon,
  Chip,
  ContentCopyIcon,
  Text,
  UploadFileIcon,
} from '@billda/design-system';
import { useSiteImportUIStore } from '../../../stores/siteImportUIStore';

const PathSelectionStep: React.FC = () => {
  const { importPath, setImportPath } = useSiteImportUIStore();

  const options = [
    {
      id: 'template' as const,
      icon: <ContentCopyIcon className="size-8" aria-hidden="true" />,
      badge: 'Quick start',
      title: 'Use a trade template',
      description:
        'Pick from a ready-made template with example plots and labour items. Great for getting started fast.',
      testId: 'path-template',
    },
    {
      id: 'csv' as const,
      icon: <UploadFileIcon className="size-8" aria-hidden="true" />,
      badge: 'Full control',
      title: 'Upload a CSV file',
      description:
        'Import your own CSV with custom plots and labour items. Use this if you already have your data prepared.',
      testId: 'path-csv',
    },
  ];

  return (
    <div
      className="grid grid-cols-1 gap-4 sm:grid-cols-2"
      data-testid="path-selection-step"
    >
      {options.map(option => {
        const isSelected = importPath === option.id;

        return (
          <div
            key={option.id}
            onClick={() => setImportPath(option.id)}
            className={`relative cursor-pointer rounded-3xl border-2 p-6 transition-all duration-150 ${
              isSelected
                ? 'border-border-focused bg-surface-primary-soft'
                : 'border-transparent bg-surface-default hover:border-border-default'
            }`}
            data-testid={option.testId}
          >
            {isSelected && (
              <div className="absolute top-3 right-3">
                <CheckCircleIcon
                  className="size-5 text-content-accent"
                  aria-hidden="true"
                />
              </div>
            )}

            <div className="mb-3 flex items-center gap-3">
              <div className="text-content-secondary">{option.icon}</div>
              <Chip label={option.badge} size="sm" />
            </div>

            <Text variant="body1" className="mb-0.5 font-semibold">
              {option.title}
            </Text>

            <Text variant="body2" color="secondary">
              {option.description}
            </Text>
          </div>
        );
      })}
    </div>
  );
};

export default PathSelectionStep;
